module.exports = __webpack_public_path__ + "img/002.2735118f.jpg";